import React, { useRef, useState } from 'react';
import Button from '../../../Components/ui/button/Button';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const ApplicationForm = () => {
  // State to manage form data and validation
  const inputRef = useRef(null);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    contactNo: '',
    currentCompany: '',
    linkedinUrl: '',
    websiteUrl: '',
    additionalInfo: '',
    resume: null,
  });

  const [errors, setErrors] = useState({});

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Validate the form
  const validateForm = () => {
    let formErrors = {};
    if (!formData.fullName) formErrors.fullName = 'Full Name is required';
    if (!formData.email) formErrors.email = 'Email Id is required';
    if (!formData.contactNo) formErrors.contactNo = 'Contact No. is required';
    if (!formData.resume) formErrors.resume = 'Resume is required';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Proceed with form submission logic (e.g., API call)
    }
  };

  return (
    <div className="-mt-20 pt-20">
      <div className="fredoka mb-6 text-[24px] font-medium capitalize leading-[27px] text-[#012E33]">
        Submit Your Application
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-[26px]">
        <div className="flex flex-col gap-2 lg:flex-row lg:items-center ">
          <label htmlFor="resume" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Resume / CV *
          </label>
          <input
            type="file"
            ref={inputRef}
            id="resume"
            name="resume"
            accept=".pdf,.doc,.docx"
            className=" hidden w-1/2  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4  lg:w-auto"
            onChange={handleChange}
          />

          <div
            onClick={() => inputRef.current.click()}
            className=" flex w-full items-center gap-4  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4  lg:w-72"
          >
            <img className="w-6" src="/images/icons/Paperclip.svg" alt="" />
            <div className="fredoka text-[18px] text-[#678285]">Attach Resume / CV</div>
          </div>
          <div className="flex items-center gap-2">
            {formData.resume?.name && <PictureAsPdfIcon className="text-red-500" />}
            {formData.resume?.name}
            {errors.resume && <div className="text-sm text-red-500">{errors.resume}</div>}
          </div>
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="fullName" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Full Name *
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && <div className="text-sm text-red-500">{errors.fullName}</div>}
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="email" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Email Id *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <div className="text-sm text-red-500">{errors.email}</div>}
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="contactNo" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Contact No. *
          </label>
          <input
            type="text"
            id="contactNo"
            name="contactNo"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.contactNo}
            onChange={handleChange}
          />
          {errors.contactNo && <div className="text-sm text-red-500">{errors.contactNo}</div>}
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="currentCompany" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Current Company
          </label>
          <input
            type="text"
            id="currentCompany"
            name="currentCompany"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.currentCompany}
            onChange={handleChange}
          />
        </div>

        <div className="fredoka mb-6 text-[24px] font-medium capitalize leading-[27px] text-[#012E33]">
          Links
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="linkedinUrl" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            LinkedIn URL
          </label>
          <input
            type="text"
            id="linkedinUrl"
            name="linkedinUrl"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.linkedinUrl}
            onChange={handleChange}
          />
        </div>

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
          <label htmlFor="websiteUrl" className="fredoka min-w-40 text-[18px] text-[#012E33]">
            Website/Portfolio
          </label>
          <input
            type="text"
            id="websiteUrl"
            name="websiteUrl"
            className=" w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            value={formData.websiteUrl}
            onChange={handleChange}
          />
        </div>

        <div className="flex flex-col gap-2 md:!mt-[72px]">
          <label
            htmlFor="additionalInfo"
            className="fredoka text-[24px] font-medium capitalize leading-[27px] text-[#012E33] md:mb-[31px]"
          >
            Additional Information
          </label>
          <textarea
            id="additionalInfo"
            name="additionalInfo"
            placeholder="Add a Cover Letter or anything else you want to share"
            className="w-full  rounded-2xl border border-[#DCDCDC] bg-[#F5F5F5] p-4 "
            rows="8"
            value={formData.additionalInfo}
            onChange={handleChange}
          />
        </div>

        <div className="flex w-full items-center justify-center lg:justify-start">
          <div className="w-[189px]">
            <Button type="submit" label={'Submit'} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ApplicationForm;
